export default "__VITE_ASSET__9889dcd8__"